<template>
    <div>
        <div><span class="icon-picto-horloge"></span>
            <p>Heure locale</p></div>
        <p class="infinite-bar">{{ formattedDate }} <span>{{ label }}</span></p>

    </div>
</template>

<script>
    import {DateTime} from 'luxon';

    export default {
        props: {
            zone: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                now: Date.now(),
            };
        },
        computed: {
            dateObject() {
                return DateTime.fromMillis(this.now, {zone: this.zone});
            },
            formattedDate() {
                return this.dateObject.toFormat('\'h\'HH\'.m\'mm\'.s\'ss');
            },
            label() {
                return this.dateObject.offsetNameShort;
            },
        },
        created() {
            setInterval(() => this.now = Date.now(), 1000);
        },
    }
</script>


// WEBPACK FOOTER //
// assets/js/components/LocalTime.vue